export default "__VITE_ASSET__193988b2__"